'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

var _sizes = require('HubStyleTokens/sizes');

var _misc = require('HubStyleTokens/misc');

var _Styles = require('../../utils/Styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H3 = (0, _styledComponents2.default)(_Heading2.default).withConfig({
  displayName: 'H3'
})(['', ';', ';'], _Styles.FONT_FAMILIES[_misc.HEADING_WEIGHT3], (0, _Styles.setFontSize)(_sizes.HEADING3));

H3.propTypes = _extends({}, _Heading2.default.propTypes);

H3.defaultProps = _extends({}, _Heading2.default.defaultProps, { tagName: 'h3' });

H3.displayName = 'H3';

exports.default = H3;
module.exports = exports['default'];